export const RookeryBoldFont = 'Rookery-Bold';
export const RookeryRegularFont = 'Rookery-Regular';
export const Montserrat = 'Montserrat';
